import React from 'react';
import Manage from './Manage';
import { LeadSourcesProvider } from '../../../contexts/LeadSourceContext';

const LeadSourcesPage = () => {
    return (
        <LeadSourcesProvider>
            <Manage />
        </LeadSourcesProvider>
    );
};

export default LeadSourcesPage;
